// @ts-strict-ignore
import React from 'react'
import i18next from 'i18next'
import { DataListItem } from '@node-space/ui-components'
import { ellipseMiddleText } from '@node-space/utils'

interface UserCryptoWithdrawalProps {
  amountWithCurrency: string
  transactionDate: string
  transactionHash: string
  recipientDetails: string
}

const UserCryptoWithdrawal = ({
  amountWithCurrency,
  transactionDate,
  transactionHash,
  recipientDetails,
}: UserCryptoWithdrawalProps) => {
  const { address: beneficiaryAddress, protocol } = JSON.parse(recipientDetails)
  return (
    <>
      {amountWithCurrency && (
        <DataListItem
          id="amount-paid"
          testId="amount-paid"
          title={i18next.t('transactions.sideBar.paymentOutAmountPaid')}
          body={amountWithCurrency}
        />
      )}
      {transactionHash && (
        <DataListItem
          id="transaction-hash"
          testId="transaction-hash"
          title={i18next.t('hash')}
          body={ellipseMiddleText(transactionHash, 20, 10)}
          copyText={transactionHash}
        />
      )}
      {transactionDate && (
        <DataListItem
          id="transaction-date"
          testId="transaction-date"
          title={i18next.t('date')}
          body={transactionDate}
        />
      )}

      {beneficiaryAddress && protocol && (
        <>
          <>
            <p className="text-h4 text-foreground-prominent mt-3">
              {i18next.t('transactions.sideBar.beneficiaryDetails')}
            </p>

            <DataListItem
              id="beneficiary-address"
              testId="beneficiary-address"
              title={i18next.t('transactions.sideBar.beneficiaryAddress')}
              body={ellipseMiddleText(beneficiaryAddress, 20, 10)}
              copyText={beneficiaryAddress}
            />
          </>
          <DataListItem
            id="protocol"
            testId="protocol"
            title={i18next.t('transactions.sideBar.protocol')}
            body={protocol}
          />
        </>
      )}
    </>
  )
}
export default UserCryptoWithdrawal
